import { useContext, useEffect } from "react";
import { Translation } from "react-i18next";
import Wave from "../../../images/wave3.svg";
import Wave2 from "../../../images/upsideDownWave5.svg";
import { GlobalAuthInfoContext } from "../../mainWrapper/MainWrapper";
import "./ReportsSidebar.scss";
import { PermissionsStatusComponent } from "../../permissionsStatusComponent/PermissionsStatusComponent";
import { ReportingPageType } from "../../../App";
import { SidebarContext } from "../../../core/SidebarComponent";
import { matchPath, useLocation } from "react-router";
import { Link } from "react-router-dom";

export interface IReportsSidebarProps {
    reportPageToShow: string
    setReportPageToShow: Function;
    visible: boolean;
    setVisible: Function;
}

export const ReportsSidebar = (props: IReportsSidebarProps) => {
    const { dispatchSidebar } = useContext(SidebarContext);

    useEffect(() => {
        dispatchSidebar({
            type: "open",
            payload: { name: "Close", content: null },
        });
    }, [dispatchSidebar]);

    const onButtonClick = (section: ReportingPageType) => {

        props.setReportPageToShow(section);
    };

    const authInfo = useContext(GlobalAuthInfoContext);

    return (
        <div className="reports-sidebar">
            <Translation>
                {(t) => (
                    <div className="content-container">
                        <div className="header">Reporting</div>
                        <div className={`card-container `}>
                            <div className="wave-div2">
                                <img src={Wave} alt="wave" className="wavy" />
                            </div>
                            <div className="inner-width-container">
                                <PermissionsStatusComponent hasPermissions={props.reportPageToShow !== "alertMessagePage"} />
                                <AuthGuardedComponent
                                    routePath="/reports/manage-project-data"
                                    componentNames={["manageProjectData"]}
                                    translationName="managePojData1" />
                                <AuthGuardedComponent
                                    routePath="/reports/build-watershed-form"
                                    componentNames={["buildWatershedFormGroupLead", "buildWatershedFormJuris"]}
                                    translationName="buildWatershedForm" />
                                <AuthGuardedComponent
                                    routePath="/reports/build-ann-report-form"
                                    componentNames={["buildAnnReportForm"]}
                                    translationName="buildAnnReport" />
                                <AuthGuardedComponent
                                    routePath="/reports/configure-milestones"
                                    disabled
                                    componentNames={["configureMilestones"]}
                                    translationName="configureMileStone" />
                                <AuthGuardedComponent
                                    routePath="/reports/configure-project-assumptions"
                                    disabled
                                    componentNames={["configureProjAssumptions"]}
                                    translationName="configureProject" />
                                <AuthGuardedComponent
                                    routePath="/userManagement"
                                    componentNames={["userManagement", "userManagementInterestedParties"]}
                                    translationName="userManagement" />
                            </div>
                            <div className="wave-div2">
                                <img src={Wave2} alt="wave" className="wavy" />
                            </div>
                        </div>
                    </div>
                )}
            </Translation>
        </div>
    );
};

type AuthGuardedComponentProps = {
    componentNames: string[]
    routePath: string,
    translationName: string
    disabled?: boolean
}
function AuthGuardedComponent(props: AuthGuardedComponentProps) {
    const authInfo = useContext(GlobalAuthInfoContext);

    function hasVisibleComponent(): boolean {
        return props.componentNames.some(cn => authInfo.visibleComponents.indexOf(cn) > -1);
    }

    const location = useLocation();
    const match = matchPath(props.routePath, location.pathname);
    console.log("routePath, pathname, match", props.routePath, location.pathname, !!match);

    return <Translation>
        {(t) => (
            hasVisibleComponent() &&
            <Link
                className={`card-div ${!!match ? "active-custom" : ""} ${props.disabled ? "disabled" : ""}`}
                to={!props.disabled ? props.routePath : undefined} >
                {!props.disabled && t(props.translationName)}
                {props.disabled && <>
                    <span className="not-overlay">{t(props.translationName)}</span>
                    <span className="overlay">COMING SOON</span>
                </>}
            </Link>)}
    </Translation>
}
